export default __webpack_public_path__ + "static/media/Tunic of the Harbinger.64a55f66.jpg";